import { GetStaticProps } from "next";
import styled from "styled-components";
import Footer from "~/components/Footer";
import { AVAILABLE_LOCALES } from "~/core/locale";
import { homepageRoute } from "~/core/routes";
import { Stack } from "~/guidelines/Flex";
import { serverSideTranslations } from "~/translations/serverSideTranslations";
import { ServerSideGeneratedI18nNamespace } from "~/translations/types";
import SimpleHeader from "../new-home/_components/SimpleHeader";
import AddedValuesSection from "./_components/AddedValuesSection";
import ConnectedHotelsSection from "./_components/ConnectedHotelsSection";
import HeroSection from "./_components/HeroSection";
import InFigures from "./_components/InFigures";
import InvestorTypeTabs from "./_components/InvestorTypeTabs";
import OurPartners from "./_components/OurPartners";
import OurProjects from "./_components/OurProjects";
import Specifications from "./_components/Specifications";
import Team from "./_components/Team";

const Layout = styled(Stack)`
  background-color: ${({ theme }) => theme.color.background.lightFirst};
  align-items: center;
`;

const SecondaryLayout = styled(Stack)`
  background-color: ${({ theme }) => theme.color.background.lightSecond};
  width: 100%;
`;

interface InvestPageProps extends ServerSideGeneratedI18nNamespace {
  locale: AVAILABLE_LOCALES;
}

const InvestPage = (props: InvestPageProps) => {
  return (
    <Layout>
      <SimpleHeader
        logoHref={homepageRoute()}
        currentLocale={props.locale}
        availableLocales={Object.values(AVAILABLE_LOCALES)}
        onLocaleChange={(newLocale) => {
          window.location.assign(`/${newLocale}/investisseurs`);
        }}
        withInstagram={false}
        variant="light"
        positionType="relative"
      />
      <HeroSection />
      <ConnectedHotelsSection />
      <InvestorTypeTabs />
      <AddedValuesSection />

      <SecondaryLayout>
        <Specifications />
        <InFigures />
        <OurPartners />
      </SecondaryLayout>

      <OurProjects />

      <SecondaryLayout>
        <Team />
      </SecondaryLayout>

      <Footer
        pressKitUrl={"/"}
        currentLocale={props.locale}
        availableLocales={Object.values(AVAILABLE_LOCALES)}
        onLocaleChange={(newLocale) => {
          window.location.assign(`/${newLocale}/investisseurs`);
        }}
      />
    </Layout>
  );
};

export const getStaticProps: GetStaticProps<InvestPageProps> = async (
  context,
) => {
  return {
    props: {
      locale: context.locale as AVAILABLE_LOCALES,
      ...(await serverSideTranslations(context.locale as AVAILABLE_LOCALES)),
    },
  };
};

export default InvestPage;
